import React from 'react'
import Button from '@components/Button'

import styles from './styles.module.css'

export default function Success({code}) {
  return (
    <div className={styles.head}>
      <h1>Reclamo Nº R#{code}</h1>
      <p className={styles.title}>
        <strong>
          ¡Tu reclamo ha sido ingresado correctamente y te enviamos un correo con el detalle del
          reclamo!
        </strong>
      </p>
      <p>Un asesor se pondrá en contacto contigo en un plazo no mayor a 15 días hábiles.</p>
      <br />
      <Button to="/">Volver al inicio</Button>
    </div>
  )
}
